export { default } from "./TicketDetailScreen.style";
